"use client";

import MapContainer from "@/components/Util/Map/MapContainer";
import { Modal } from "@/components/Util/Modal";
import { useTranslation } from "@/app/i18n/client";
import { useState } from "react";
import { Company, CompanyInfoType } from "@/types/company";
import { AdvertiserLocationWithCompany } from "@/types/location";
import { getGoogleMapsLinkWithAddress } from "@/utils/Utils";
import { MarkerType } from "@/components/Util/Map/Map";
import {
  MdEmail,
  MdPhone,
  MdPhoneAndroid,
  MdPlace,
  MdPrint,
  MdPublic,
  MdPerson,
} from "react-icons/md";

export function ProfileMap({
  locations,
  height,
  company,
}: {
  locations: AdvertiserLocationWithCompany[];
  height: string;
  company: Company<"travelService">;
}) {
  console.log("Locations: ", locations);
  const { t, i18n } = useTranslation("profile");
  const [showMarkerInfo, setShowMarkerInfo] = useState(false);
  const [currentLocations, setCurrentLocations] =
    useState<AdvertiserLocationWithCompany[]>();

  function showSingleMarkerModal(locationId: string): void {
    const location = locations?.filter(
      (loc) => loc.advertiserLocation.id === locationId,
    );
    if (location?.length > 0) {
      console.log(location);
      setCurrentLocations([location[0]]);
      setShowMarkerInfo(true);
    }
  }

  function showClusterModal(locationIds: string[]): void {
    const filteredLocations = locations?.filter((loc) =>
      locationIds.includes(loc.advertiserLocation.id),
    );
    if (filteredLocations?.length > 0) {
      console.log(filteredLocations);
      setCurrentLocations(filteredLocations);
      setShowMarkerInfo(true);
    }
  }

  return (
    <>
      <MapContainer
        showClusterModal={showClusterModal}
        showSingleMarkerModal={showSingleMarkerModal}
        visibleItems={locations.map((al) => al.advertiserLocation)}
        hideSearchField
        type={MarkerType.Advertiser}
        height={height}
      />
      <Modal
        header={
          t("PROFILEFORM.CONTACT.LABEL") + ": " + company.publicData.companyName
        }
        modalDidClose={() => {
          setShowMarkerInfo(false);
        }}
        open={showMarkerInfo}
        disableOverflow
        className="max-w-3xl"
      >
        <div>
          <div className="flex flex-col gap-2">
            {currentLocations?.map((location) => (
              <div
                key={location.advertiserLocation.id}
                className="border-0 border-b border-dashed border-secondary pb-2 last:border-0"
              >
                <p className="my-1 text-lg font-semibold">
                  {t("PROFILEFORM.MODAL.LOCATION")}{" "}
                  {location.advertiserLocation.address.address}
                </p>
                <ContactElement
                  icon={<MdPerson />}
                  type="name"
                  value={location.advertiserLocation.contact.contactName}
                />
                <ContactElement
                  icon={<MdEmail />}
                  type="email"
                  value={location.advertiserLocation.contact.email}
                  hasLink
                />
                <ContactElement
                  icon={<MdPhone />}
                  type="telephone"
                  value={location.advertiserLocation.contact.telephone}
                  hasLink
                />
                <ContactElement
                  icon={<MdPhoneAndroid />}
                  type="telephone"
                  value={location.advertiserLocation.contact.cellphone}
                  hasLink
                />
                <ContactElement
                  icon={<MdPrint />}
                  type="telephone"
                  value={location.advertiserLocation.contact.fax}
                  hasLink
                />
                <ContactElement
                  icon={<MdPublic />}
                  type="website"
                  value={location.advertiserLocation.contact.website}
                  hasLink
                />
                <ContactElement
                  icon={<MdPlace />}
                  type="address"
                  value={location.advertiserLocation.address.address}
                  hasLink
                />
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
}

function ContactElement({
  icon,
  type,
  value,
  hasLink,
}: {
  icon: React.ReactNode;
  type: CompanyInfoType;
  value: string | undefined;
  hasLink?: boolean;
}) {
  if (!value) return null;

  return (
    <div className="flex items-center">
      <div className="icon w-4 text-secondary">{icon}</div>
      <div>
        {" "}
        :{" "}
        {hasLink ? (
          <a
            href={
              type === "email"
                ? `mailto:${value}`
                : type === "address"
                  ? getGoogleMapsLinkWithAddress(value)
                  : type === "telephone"
                    ? `tel:${value}`
                    : value
            }
          >
            {value}
          </a>
        ) : (
          <span>{value}</span>
        )}
      </div>
    </div>
  );
}
